/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    PASSED: 'passed',
    ACTIVE: 'active',
    CANCELED: 'canceled',
    CANCELED_WAITLIST: 'canceled_waitlist',
    CANCELED_WAITLIST_BY_OFFICE: 'canceled_waitlist_by_office',
    CANCELED_BY_OFFICE: 'canceledByOffice',
    WAITLIST: 'waitlist',
};
